/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Generic error information provided by the backend. This will never contain sensitive technical details. Especially no stack traces.
 */
export interface ApiError {
  /**
   * Unique ID for the error message.
   */
  errorCode: string;
  /**
   * This message is intended for display at presentation layer. Always in german.  **Note**: This user message is optional.
   */
  userMsg?: string;
  /**
   * Technical details for error analysis. NOT intended for display at presentation layer.
   */
  systemMsg?: string;
}
